<template>
  <div>
    <p class="font-semibold mb-3">{{ $t('pages.shop.checkout.tab1.priceDetails') }}</p>
    <div class="flex justify-between mb-2">
      <span class="text-grey">{{ $t('pages.shop.checkout.tab1.totalPlanningService') }}</span>
      <span class="text-primary" v-if="$store.state.Profile.isBRL()">{{ $store.getters['Shop/getAllServicePlanningPrice'] | BRL }}</span>
      <span class="text-primary" v-else>{{ $store.getters['Shop/getAllServicePlanningPrice'] | USD }}</span>
    </div>

    <div class="flex justify-between mb-2">
      <span class="text-grey">{{ $t('pages.shop.checkout.tab1.totalComboDiscount') }}</span>
      <span class="text-danger" v-if="$store.state.Profile.isBRL()">{{ $store.getters['Shop/getAllComboDiscount'] | BRL }}</span>
      <span class="text-danger" v-else>{{ $store.getters['Shop/getAllComboDiscount'] | USD }}</span>
    </div>

    <div class="flex justify-between mb-2">
      <span class="text-grey">{{ $t('pages.shop.checkout.tab1.totalManufactureService') }}</span>
      <span class="text-primary" v-if="$store.state.Profile.isBRL()">{{ $store.getters['Shop/getAllServiceManufacturePrice'] | BRL }}</span>
      <span class="text-primary" v-else>{{ $store.getters['Shop/getAllServiceManufacturePrice'] | USD }}</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="text-grey">{{ $t('pages.shop.checkout.tab1.cupomDiscount') }}</span>
      <span class="text-danger" v-if="$store.state.Profile.isBRL()">{{ $store.getters['Shop/getCoupomDiscount'] | BRL }}</span>
      <span class="text-danger" v-else>{{ $store.getters['Shop/getCoupomDiscount'] | USD }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutServicePriceBox"
}
</script>

<style scoped>

</style>
